import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import ImportExcel from "./ImportExcel";

export default class Invoices extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'invoice',
            data: null,
            loading: true,
            id_to_remove: null,
            page: 1,
            per_page: 30,
            phrase: '',
            selected: [],
            filters: {
                filter: 0,
                type: 0,
                inp: 0,
                ins: 0,
                inty: 0,
                note: '',
                inno: '',
                customerName: '',
                sort: 0
            },
            task: 0,
        };
    }
    componentDidMount() {
        this.refreshData();
    }
    enqueue(id) {
        this.sendEnqueue([id]);
    }
    sendEnqueue(ids) {
        this.httpPost("api/v1/invoice/enqueue", {
            ids: ids,
            companyId: this.state.data.global.company.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("ارسال با موفقیت انجام پذیرفت گردید");
                    this.refreshData();
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    reference(id) {
        this.httpPost("api/v1/invoice/reference", {
            id: id,
            companyId: this.state.data.global.company.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";

                if (data.status === 1) {
                    this.showSuccessMessage("استعلام صورتحساب دریافت شد");
                    this.setState({
                        redirect: "/invoice/edit/" + id
                    })
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    getToolBars(record) {
        var m = [];
        m.push(<li><NavLink to={"/invoice/view/" + record.id} title="مشاهده"><em className="icon ni ni-eye"></em> <span>مشاهده</span></NavLink></li>);
        if (record.status === 1 || record.status === 3 || record.sendToTax) {
            m.push(<li><NavLink to={"/invoice/edit/" + record.id} title="ویرایش"><em className="icon ni ni-pen"></em> <span>ویرایش</span></NavLink></li>);
            m.push(<li><a className="hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف"><em className="icon ni ni-na"></em> <span>حذف صورتحساب</span></a></li>);
        }
        if (record.status === 1 || record.status === 3) {
            m.push(<li><a className="hand" onClick={e => this.enqueue(record.id)} title="ارسال به سامانه"><em class="icon ni ni-send"></em> <span>ارسال به سامانه</span></a></li>);
        }
        if (record.status === 2) {
            m.push(<li><a className="hand" onClick={e => this.reference(record.id)} title="استعلام"><em class="icon ni ni-search"></em> <span>استعلام صورتحساب</span></a></li>);
        }
        if (record.status === 4 || record.sendToTax) {
            m.push(<li><NavLink to={"/invoice/cancell/" + record.id} title="صدور ابطالی"><em class="icon ni ni-property-remove"></em> <span>صدور ابطالی</span></NavLink></li>);
            m.push(<li><NavLink to={"/invoice/modify/" + record.id} title="صدور اصلاحی"><em class="icon ni ni-property-add"></em> <span>صدور اصلاحی</span></NavLink></li>);
            m.push(<li><NavLink to={"/invoice/return/" + record.id} title="صدور برگشت از فروش"><em class="icon ni ni-property-alt"></em> <span>صدور برگشت از فروش</span></NavLink></li>);
        }
        return m;
    }
    onImportParsian() {
        this.removeKeyDown();
        this.showComponents({ component: <ImportExcel Caller={this} Type={40} CompanyId={this.state.data.global.company.id} /> });
    }
    onImportIranKhodro() {
        this.removeKeyDown();
        this.showComponents({ component: <ImportExcel Caller={this} Type={50} CompanyId={this.state.data.global.company.id} /> });
    }
    onImportSipa() {
        this.removeKeyDown();
        this.showComponents({ component: <ImportExcel Caller={this} Type={60} CompanyId={this.state.data.global.company.id} /> });
    }
    onImport(type) {
        this.removeKeyDown();
        this.showComponents({ component: <ImportExcel Caller={this} Type={type} CompanyId={this.state.data.global.company.id} /> });
    }
    setType(e, v) {
        this.state.filters.type = v;
        this.refreshData();
    }
    doTask(e) {
        this.httpPost("api/v1/invoice/task", {
            task: this.state.task,
            selected: this.state.selected,
            companyId: this.state.data.global.company.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage(data.taskResult);
                    this.state.selected = [];
                    this.refreshData();
                }
                else
                    this.showErorrMessage(data.message);
            })
            .catch(err => {
                this.showErorrMessage("پاسخی دریافت نشد.لطفا مجدد تلاش نمایید.");
            });
    }
    select(id, e) {
        var t = [];
        this.state.selected.forEach(f => {
            if (f != id) t.push(f);
        });
        if (e.target.checked) t.push(id);
        this.setState({ selected: t });
    }
    renderForm() {
        if (this.state.data.status == -2) return this.renderSystemModuleNotFound();
        if (this.state.data.status == -3) return this.renderSystemModuleExpired();
        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            <div className="nk-block-des text-soft">
                                <p>شما {this.money(this.state.data.recordsCount)} صورتحساب ثبت شده دارید</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        {1 == 2 && <li>
                                            <a onClick={e => this.getPdfs(e)} className="btn btn-white btn-outline-light"><em class="icon ni ni-file-pdf"></em><span>خروجی PDF اطلاعات</span></a>
                                        </li>}
                                        {this.state.data.parsian && <li>
                                            <a onClick={e => this.onImportParsian()} className="hand btn btn-success"><em className="icon ni ni-file-xls"></em><span>اکسل پارسیان</span></a>
                                        </li>}
                                        {this.state.data.irankhodro && <li>
                                            <a style={{ "backgroundColor": "#0157a0" }} onClick={e => this.onImportIranKhodro()} className="hand btn btn-success"><em className="icon ni ni-file-xls"></em><span>اکسل ایران خودرو</span></a>
                                        </li>}
                                        {this.state.data.saipa && <li>
                                            <a style={{ "backgroundColor": "#e87816" }} onClick={e => this.onImportSipa()} className="hand btn btn-success"><em className="icon ni ni-file-xls"></em><span>اکسل سایپا</span></a>
                                        </li>}
                                        <li className="nk-block-tools-opt">
                                            <div className="drodown">
                                                <a href="#" className="dropdown-toggle btn btn-danger" data-bs-toggle="dropdown" aria-expanded="true">
                                                    ایمپورت اکسل</a>
                                                <div className="dropdown-menu dropdown-menu-end" data-popper-placement="bottom-end">
                                                    <ul className="link-list-opt no-bdr">
                                                        <li><a onClick={e => this.onImport(5)}><span>فروش</span></a></li>
                                                        <li><a onClick={e => this.onImport(6)}><span>فروش ارزی</span></a></li>
                                                        <li><a onClick={e => this.onImport(7)}><span>طلا و جواهر و پلاتین</span></a></li>
                                                        <li><a onClick={e => this.onImport(8)}><span>پیمانکاری</span></a></li>
                                                        <li><a onClick={e => this.onImport(9)}><span>قبوض خدماتی</span></a></li>
                                                        <li><a onClick={e => this.onImport(10)}><span>بلیت هواپیما</span></a></li>
                                                        <li><a onClick={e => this.onImport(11)}><span>صادرات</span></a></li>
                                                        <li><a onClick={e => this.onImport(12)}><span>بارنامه</span></a></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                        <li className="nk-block-tools-opt">
                                            <div className="drodown">
                                                <a style={{ "padding-left": "10px" }} href="#" className="dropdown-toggle btn btn-icon btn-primary" data-bs-toggle="dropdown" aria-expanded="true"><em className="icon ni ni-plus"></em> ثبت دستی صورتحساب</a>
                                                <div className="dropdown-menu dropdown-menu-end" data-popper-placement="bottom-end">
                                                    <ul className="link-list-opt no-bdr">
                                                        <li><NavLink to="/invoice/new1/"><span>فروش</span></NavLink></li>
                                                        <li><NavLink to="/invoice/new2/"><span>فروش ارزی</span></NavLink></li>
                                                        <li><NavLink to="/invoice/new3/"><span>طلا و جواهر و پلاتین</span></NavLink></li>
                                                        <li><NavLink to="/invoice/new4/"><span>پیمانکاری</span></NavLink></li>
                                                        <li><NavLink to="/invoice/new5/"><span>قبوض خدماتی</span></NavLink></li>
                                                        <li><NavLink to="/invoice/new6/"><span>بلیت هواپیما</span></NavLink></li>
                                                        <li><NavLink to="/invoice/new7/"><span>صادرات</span></NavLink></li>
                                                        <li><NavLink to="/invoice/new8/"><span>بارنامه</span></NavLink></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="شماره مالیاتی" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.customerName} onChange={e => this.state.filters.customerName = e.target.value} placeholder="طرف حساب" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.inno} onChange={e => this.state.filters.inno = e.target.value} placeholder="سریال" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.note} onChange={e => this.state.filters.note = e.target.value} placeholder="یادداشتها" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.inp} onChange={e => this.state.filters.inp = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">همه الگوهای</option>
                                                    <option value="1">فروش</option>
                                                    <option value="2">فروش ارزی</option>
                                                    <option value="3">طلا و جواهر و پلاتین</option>
                                                    <option value="4">پیمانکاری</option>
                                                    <option value="5">قبوض خدماتی</option>
                                                    <option value="6">بلیت هواپیما</option>
                                                    <option value="7">صادرات</option>
                                                    <option value="8">بارنامه</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.ins} onChange={e => this.state.filters.ins = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">همه موضوعات</option>
                                                    <option value="1">اصلی</option>
                                                    <option value="2">ابطالی</option>
                                                    <option value="3">اصلاحی</option>
                                                    <option value="4">برگشت از فروش</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.inty} onChange={e => this.state.filters.inty = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">همه نوع</option>
                                                    <option value="1">اول</option>
                                                    <option value="2">دوم</option>
                                                    <option value="3">سوم</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.filter} onChange={e => this.state.filters.filter = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">بدون فیلتر</option>
                                                    <option value="1">غیرماده 9</option>
                                                    <option value="2">فقط ماده 9</option>
                                                </select>
                                            </div>
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.filters.sort} onChange={e => this.state.filters.sort = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">تاریخ صورتحساب(نزولی)</option>
                                                    <option value="1">تاریخ صورتحساب(صعودی)</option>
                                                    <option value="2">مبلغ صورتحساب(نزولی)</option>
                                                    <option value="3">مبلغ صورتحساب(صعودی)</option>
                                                    <option value="4">شماره مالیاتی(نزولی)</option>
                                                    <option value="5">شماره مالیاتی(صعودی)</option>
                                                    <option value="6">سریال(نزولی)</option>
                                                    <option value="7">سریال(صعودی)</option>
                                                </select>
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <div className="card-tools">
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <select defaultValue={this.state.task} onChange={e => this.state.task = parseInt(e.target.value)} className="form-control">
                                                    <option value="0">عملیات دسته جمعی</option>

                                                    <option value="1">حذف همه ارسال نشده ها</option>
                                                    <option value="2">حذف همه صورتحسابهای دارای خطا</option>
                                                    <option value="3">ارسال دسته جمعی (تا سقف 100 صورتحساب)</option>
                                                    <option value="4">استعلام دسته جمعی</option>

                                                    <option value="5">حذف ارسال نشده های انتخابی</option>
                                                    <option value="6">حذف صورتحسابهای دارای خطا انتخاب شده</option>
                                                    <option value="7">ارسال دسته جمعی انتخاب شده ها (تا سقف 100 صورتحساب)</option>
                                                    <option value="8">استعلام انتخاب شده ها</option>
                                                </select>
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block">
                                                    <a onClick={e => this.doTask(e)} className="btn btn-danger hand">اجرا</a>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="my-2">
                                <div className="card-inner">
                                    <ul className="nav nav-tabs mt-n3">
                                        <li className="nav-item">
                                            <a className={"hand nav-link " + (this.state.filters.type === 0 ? "active" : "")} onClick={e => this.setType(e, 0)}><span>همه</span></a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={"hand nav-link " + (this.state.filters.type === 1 ? "active" : "")} onClick={e => this.setType(e, 1)}><span>ارسال نشده</span></a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={"hand nav-link " + (this.state.filters.type === 2 ? "active" : "")} onClick={e => this.setType(e, 2)}><span>استعلام نشده</span></a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={"hand nav-link " + (this.state.filters.type === 3 ? "active" : "")} onClick={e => this.setType(e, 3)}><span>دارای خطا</span></a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={"hand nav-link " + (this.state.filters.type === 4 ? "active" : "")} onClick={e => this.setType(e, 4)}><span>ارسال موفقیت آمیز</span></a>
                                        </li>
                                        <li className="nav-item">
                                            <a className={"hand nav-link " + (this.state.filters.type === 5 ? "active" : "")} onClick={e => this.setType(e, 5)}><span>ارسالی خارج از سیستم</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            {this.state.data.recordsCount <= 0 ?
                                <div className="example-alert">
                                    <div className="alert alert-pro alert-warning">
                                        <div className="alert-text">
                                            <h6>توجه</h6>
                                            <p>صورتحسابی یافت نشد</p>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col"><span className="sub-text"></span></div>
                                            <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>
                                            <div className="nk-tb-col"><span className="sub-text">الگو</span></div>
                                            <div className="nk-tb-col"><span className="sub-text">موضوع</span></div>
                                            <div className="nk-tb-col"><span className="sub-text">نوع</span></div>
                                            <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">سریال</span></div>
                                            <div className="nk-tb-col tb-col-lg"><span className="sub-text text-center">شماره منحصربفرد مالیاتی</span></div>
                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">شماره مالیاتی مرجع</span></div>
                                            <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">تاریخ</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center">طرف حساب</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center">ماده 9</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center">یادداشتها</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center">مبلغ کل</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text text-center">وضعیت</span></div>
                                            <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">
                                                        <input type="checkbox" checked={this.state.selected.includes(record.id)} onChange={e=>this.select(record.id,e) } />
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">{this.genRowNumber(index)}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">{record.inpString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">{record.insString}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text">{record.intyString}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-sm">
                                                    <span className="sub-text text-center">{record.inno}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">{record.taxId}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">{record.irtaxId}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center">{record.indatimPersian}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center">{record.customerName}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center">{record.insr === 1 ? "بله" : "خیر"}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center">{record.nti1}<br />{record.nti2}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg">
                                                    <span className="sub-text text-center">{this.money(record.tbill)}</span>
                                                </div>
                                                <div className="nk-tb-col tb-col-lg text-center">
                                                    {record.status === 1 && <span class="tb-status text-info">{record.statusString}</span>}
                                                    {record.status === 2 && <span class="tb-status text-warning">{record.statusString}</span>}
                                                    {record.status === 3 && <span class="tb-status text-danger">{record.statusString}</span>}
                                                    {record.status === 4 && <span class="tb-status text-success">{record.statusString}</span>}
                                                </div>
                                                <div className="nk-tb-col nk-tb-col-tools">
                                                    <ul className="nk-tb-actions gx-1">
                                                        <li>
                                                            <div className="drodown">
                                                                <a href="#" className="dropdown-toggle btn btn-icon btn-trigger" data-bs-toggle="dropdown"><em className="icon ni ni-more-h"></em></a>
                                                                <div className="dropdown-menu dropdown-menu-end">
                                                                    <ul className="link-list-opt no-bdr">
                                                                        {this.getToolBars(record)}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent()
            ];

        return contents;
    }
}